import React, {useEffect, useState, Fragment} from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {FormattedMessage, injectIntl} from "react-intl";

import {getCurrentLayout} from "../../../../appLayout";
import MaterialSpinner from "../../../../ui/materialSpinner";
import LookVirtualizedList from "./lookVirtualizedList";
import {useIsMounted, usePrevious} from "../../../../../misc/helperHooks";
import GroheVirtualizedList from "../../../grohe/groheNavigation/groheFeatures/groheVirtualizedList";
import {getFeatureGroupName, getFeatureIsLocked} from "../../../../../misc/helpers";
import {LOOK_NAVIGATION_LIST_TYPES, LOOK_OVERLAYS} from "../../../core/constants";
import {IS_PRODUCT_JOURNEY} from "../../../../../config";
import {getLixilRequiredNotIncludedFeatures} from "../../../grohe/groheNavigation/groheFunctions";
import {setGroheRequiredButNotIncludedFeature} from "../../../../../actions/groheFunctions";
import LookFeatureRemoveButton from "../lookFeatureRemoveButton";
import WithUpdateLookCartItem from "../../../hocs/withUpdateLookCartItem";
import LookListFeature from "../lookListFeature/lookListFeature";
import LookFiltersReset from "../../lookFilters/lookFiltersReset";
import {
  getReorderedItems,
  getNavigationItemsLists,
  getSortedNavItems,
  pricingIsLocked, getReplacedNavItemsWithUnlockedFeatures
} from "../../lookNavigationFunctions";
import {setLookLockedTutorial} from "../../../../../actions/lookFunctions";
import {scrolledVerticalToTheEnd} from "../../../../visComponents/navigation/navUtils";
import {checkIfLookFeaturesReceived, getAdditionalFeaturesOnScroll} from "../../../../../api/look-api";
import NavigationLoader from "../../../ui/navigationLoader";
// import {COUNTERTOP_GROUP} from "../../../../kvComponent/core/constants";
import {
  checkIfNeedToReceiveFeaturesIfFiltersApplied,
  getFeaturesFromBackendWithFilters
} from "../../../../../misc/filtersFunctions";
import LookMainCategoryLoading from "./lookMainCategoryLoading";
import Analytics from "../../../../../analytics";
import {getAnalyticsEcommerceItem} from "../../../../../analyticsEcommerceParams";
import {setNavigationLoading} from "../../../../../actions/navigationFunctions";


const LookMainCategory = (props) => {

  const {lookActiveFeature, lookViewType, lookActiveCategory, contentHeight, isMobile, filterGroups, intl,
    fabricatorData, groheFiltersSearchText, selectedFilters, requiredButNotIncludedFeature, navigationCount,
    setGroheRequiredButNotIncludedFeature, lookActiveFeaturePositionInList, lookViewTypeWasChanged, lookLockedTutorial,
    setLookLockedTutorial, allFeaturesWereLoaded, contextMenu, wizardActiveItem, navigationLoadingActive,
    setNavigationLoading, isPhoneNumberValidated, lookOverlayOpened} = props;

  const [navItemsLists, setNavItemsLists] = useState([]);
  const [firstOpenedFeature, setFirstOpenedFeature] = useState(null);
  const [firstOpenedConditions, setFirstOpenedConditions] = useState(null);

  const [shouldRunAnalytics, setShouldRunAnalytics] = useState(false);

  const isMounted = useIsMounted();
  const prevActiveCategory = usePrevious(lookActiveCategory);

  const layout = getCurrentLayout();
  const featureGroup = lookActiveFeature ? lookActiveFeature.getParent() : layout.getFeatureGroupByPartId(lookActiveCategory);

  // const [, forceUpdate] = useReducer(x => x + 1, 0);

  const setReceivedFeatures = async () => {
    if (lookActiveCategory && isMounted()) {
      let forFeature = lookActiveFeature;
      if (featureGroup && !featureGroup.allFeaturesReceived && !featureGroup.requestInProgress) {
        setShouldRunAnalytics(true);
        checkIfLookFeaturesReceived(featureGroup);
        return // we will update this component when navigationCount is changed
      }
      if (Array.isArray(selectedFilters) && selectedFilters.length && featureGroup && !featureGroup.requestInProgress) {
        const checkPassed = checkIfNeedToReceiveFeaturesIfFiltersApplied(selectedFilters, featureGroup);
        if (checkPassed) {
          setNavigationLoading(true);
          await getFeaturesFromBackendWithFilters(featureGroup, checkPassed.arrayOfNeededFiltersToReceive);
          if (!isMounted()) {
            return
          }
          setNavigationLoading(false);
        }
      }
      if (!forFeature && featureGroup && isMobile && !IS_PRODUCT_JOURNEY) {
        forFeature = featureGroup.activeFeature
      }
      let navFeatures;
      if (requiredButNotIncludedFeature) {
        navFeatures = getLixilRequiredNotIncludedFeatures(requiredButNotIncludedFeature).map((feature) => ({part: feature}))
        setNavItemsLists([{
          type: LOOK_NAVIGATION_LIST_TYPES.regular,
          navItems: navFeatures
        }]);
      } else if (featureGroup) {
        const firstFeature = firstOpenedFeature && firstOpenedFeature.partId === lookActiveCategory ? firstOpenedFeature : null;
        const firstConditions = firstOpenedFeature && firstOpenedFeature.partId === lookActiveCategory ? firstOpenedConditions : null;
        navFeatures = layout.designNavigationItems(
          {part: featureGroup},
          selectedFilters,
          groheFiltersSearchText,
          forFeature,
          "all", // added for non lixil fabricators to display not in visualizer features
          filterGroups,
          {firstFeature, firstConditions},
        );

        if (featureGroup.partId === "vanity_sink" && contextMenu.clickedOnItem) {
          if (contextMenu.clickedOnItem === "vanity_pedestal_sink") {
            navFeatures = navFeatures.filter(navItem => {
              return navItem.part && navItem.part.metaData["MountType"] && navItem.part.metaData["MountType"].includes("ST")
            })
          } else if (contextMenu.clickedOnItem === "vanity_sink") {
            navFeatures = navFeatures.filter(navItem => {
              if (!navItem.part) {
                return false
              }
              return !navItem.part.metaData["MountType"] || !navItem.part.metaData["MountType"].includes("ST")
            })
          }
        }

        navFeatures = getReplacedNavItemsWithUnlockedFeatures(navFeatures, filterGroups);

        // here we sort features
        navFeatures = getReorderedItems(navFeatures, lookActiveFeature,
          lookActiveCategory, featureGroup, false, true,
          lookViewType);

        if (!wizardActiveItem && lookActiveCategory
          && (!prevActiveCategory || (prevActiveCategory !== lookActiveCategory) || shouldRunAnalytics)) {
          if (shouldRunAnalytics) {
            setShouldRunAnalytics(false);
          }
          Analytics.sendEcommerceEvent("view_item_list", {
            item_list_id: featureGroup.partId,
            item_list_name: featureGroup.dbName || featureGroup.partName || "",
            items: navFeatures.filter(navItem => navItem.part).map((navItem, navItemIndex) => {
              return getAnalyticsEcommerceItem(navItem.part, 1, navItemIndex)
            })
          });
        }

        if (typeof lookActiveFeaturePositionInList === "number") {  // swap places with clicked position (is used only for cases when 1) option click 2) navigation item click)
          const currentPositionInList = navFeatures.findIndex(navItem => navItem.part.dbFeature.id === lookActiveFeature.dbFeature.id);
          if (currentPositionInList >= 0 && currentPositionInList !== lookActiveFeaturePositionInList) {
            [navFeatures[currentPositionInList], navFeatures[lookActiveFeaturePositionInList]] = [navFeatures[lookActiveFeaturePositionInList], navFeatures[currentPositionInList]]
          }
        }

        const nItemsLists = getNavigationItemsLists(navFeatures, lookActiveFeature);

        if (fabricatorData.settings.leadCapture && !lookLockedTutorial.finished && !isPhoneNumberValidated
          && !IS_PRODUCT_JOURNEY && featureGroup.allFeaturesReceived && !(isMobile && lookActiveFeature)
          && !wizardActiveItem && !(lookOverlayOpened && (lookOverlayOpened === LOOK_OVERLAYS.intro))) {
          let firstLockedIndex, firstUnlockedIndex;
          if (nItemsLists.length === 1) {
            firstLockedIndex = nItemsLists[0].navItems.findIndex(navItem => getFeatureIsLocked(navItem.part));
            firstUnlockedIndex = nItemsLists[0].navItems.findIndex(navItem => !getFeatureIsLocked(navItem.part));
          }
          setLookLockedTutorial({
            visible: true,
            withGrid: nItemsLists.length === 1,
            firstLockedIndex,
            firstUnlockedIndex,
          })
        }

        setNavItemsLists(nItemsLists);
      }
      //console.log("navItems", navItems);
      // forceUpdate(1);
      // setTimeout(() => {
      //   if (isMounted()) {
      //     forceUpdate(1);
      //   }
      // }, 500)
      // setTimeout(() => {
      //   if (isMounted()) {
      //     forceUpdate(1);
      //   }
      // }, 1500)
      // setTimeout(() => {
      //   if (isMounted()) {
      //     forceUpdate(1);
      //   }
      // }, 3000)
    }
  };

  useEffect(() => {
    setReceivedFeatures();
    return () => {
      if (requiredButNotIncludedFeature && lookActiveFeature) {
        let reqFeatures = getLixilRequiredNotIncludedFeatures(requiredButNotIncludedFeature);
        reqFeatures.push(requiredButNotIncludedFeature);
        if (!reqFeatures.find(navItem => navItem.dbFeature.id === lookActiveFeature.dbFeature.id)) {
          setGroheRequiredButNotIncludedFeature(null);
        }
      } else if(requiredButNotIncludedFeature && !lookActiveFeature) {
        setGroheRequiredButNotIncludedFeature(null);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lookActiveCategory, groheFiltersSearchText, selectedFilters, requiredButNotIncludedFeature,
    setGroheRequiredButNotIncludedFeature, navigationCount, lookOverlayOpened, lookViewType]);

  useEffect(() => {
    if (lookActiveCategory) {
      setFirstOpenedFeature(lookActiveFeature);
      if (lookActiveFeature && lookActiveFeature.getParent) {
        setFirstOpenedConditions(lookActiveFeature.getParent().getArrayOfConditions(true))
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lookActiveCategory]);

  // if (!visualizersLoadedLength) {
  //   return <MaterialSpinner/>
  // }

  if (wizardActiveItem) { // why we need this render? not sure. probably because of the useEffect, didn't removed for now
    return null
  }

  if (IS_PRODUCT_JOURNEY && !lookActiveFeature && !(featureGroup && featureGroup.activeNotInVisualizerFeature)) {
    return (
      <div className="lm-content">
        <MaterialSpinner/>
      </div>
    )
  }

  if (featureGroup && !featureGroup.allFeaturesReceived) {
    return <LookMainCategoryLoading featureGroup={featureGroup} contentHeight={contentHeight}/>
  }

  let featureGroupName = "";
  if (IS_PRODUCT_JOURNEY) {
    featureGroupName = getFeatureGroupName(featureGroup, intl, fabricatorData);
  }

  const showFeaturesOnly = lookActiveCategory && !layout.partIdExistInQtCategory(lookActiveCategory, true); // to prevent calculating features on each render
  // const showAllWallsCheckbox = lookActiveFeature && showFeaturesOnly && LOOK_WALLS_ONLY.includes(lookActiveFeature.partId);

  const desRecNavItemList = navItemsLists.find(navItemList => navItemList.type === LOOK_NAVIGATION_LIST_TYPES.designRec);
  const regularNavItemList = navItemsLists.find(navItemList => navItemList.type === LOOK_NAVIGATION_LIST_TYPES.regular);
  const notMatchingNavItemList = navItemsLists.filter(navItemList => navItemList.type === LOOK_NAVIGATION_LIST_TYPES.notMatchingMeta);

  if (!regularNavItemList) {
    return null
  }

  const onScrollHandler = async (scrollObject) => {
    if (!featureGroup || allFeaturesWereLoaded.includes(document.kvConfig.visualizerType)) {
      return;
    }
    if (featureGroup.getRealFeaturesReceivedProperty() || !scrolledVerticalToTheEnd(scrollObject)) {
      return
    }
    setNavigationLoading(true);
    await getAdditionalFeaturesOnScroll(featureGroup);
    await setReceivedFeatures();
    await new Promise(resolve => setTimeout(resolve, 300));
    setNavigationLoading(false);
  }

  const onEventScrollHandler = (event) => {
    onScrollHandler(event.target)
  }

  if (IS_PRODUCT_JOURNEY) {
    let allProducts = regularNavItemList.navItems;
    if (desRecNavItemList && desRecNavItemList.navItems) {
      allProducts = [...desRecNavItemList.navItems, ...regularNavItemList.navItems];
    }
    if (notMatchingNavItemList && notMatchingNavItemList.length) {
      notMatchingNavItemList.forEach(navItemList => {
        allProducts = [...allProducts, ...navItemList.navItems];
      })
    }
    const {isLixil, pricingLocked} = pricingIsLocked();
    if (!isLixil && pricingLocked) {
      allProducts = getSortedNavItems(allProducts, false, lookViewType);
    }
    return (
      <Fragment>
        {isMobile ? null : (
          <Fragment>
            <div className="grohe-features__title grohe-features__title--with-margin">
              <span className="grohe-features__title-text">{featureGroupName} ({regularNavItemList.navItems.length})</span>
              {/*{showAllWallsCheckbox ? (*/}
              {/*  <div className="grohe-features__title-right">*/}
              {/*    <LookAllWallsRadioButton/>*/}
              {/*  </div>*/}
              {/*) : null}*/}
              {/*{!showAllWallsCheckbox && lookActiveFeature && lookActiveFeature.getParent().canBeDisabled && showFeaturesOnly ? (*/}
              {featureGroup && featureGroup.canBeDisabled && showFeaturesOnly ? (
                <div className="grohe-features__title-right">
                  <LookFeatureRemoveButton lookFeature={lookActiveFeature} isToggle={true} text="grohe.features.showProduct"/>
                </div>
              ) : null}
            </div>
          </Fragment>
        )}
        <div className={isMobile ? "lm-content--no-scroll" : "lm-content lm-content--no-scroll"}>
          <div className={"lm-features lm-features--type-" + lookViewType}>
            <GroheVirtualizedList renderList={allProducts} onScrollHandler={onScrollHandler}/>
          </div>
        </div>
        {navigationLoadingActive ? <NavigationLoader/> : null}
      </Fragment>
    )
  }

  return (
    <WithUpdateLookCartItem>
      {(updateLookCartItem) => {

        if (!selectedFilters.length && !desRecNavItemList && !notMatchingNavItemList.length && regularNavItemList) {
          // simple list, react virtualized, all as usual
          return (
            <Fragment>
              <div className="lm-content lm-content--no-scroll">
                <LookVirtualizedList contentHeight={contentHeight}
                                     renderList={regularNavItemList.navItems}
                                     isMobile={isMobile}
                                     onScrollHandler={onScrollHandler}
                                     updateLookCartItem={updateLookCartItem}
                                     lookViewType={lookViewType}/>
              </div>
              {navigationLoadingActive ? <NavigationLoader/> : null}
            </Fragment>
          )
        }

        return (
          <Fragment>
            <div className={"lm-content lm-content--features" + (!navigationLoadingActive ? " lm-content--loading" : "")}
                 onScroll={onEventScrollHandler}>
              {desRecNavItemList || selectedFilters.length ? (
                <Fragment>
                  <h3 className="h3 lk-title__text2 lm-features__title">
                    <FormattedMessage id="look.features.recommended.title"/>
                  </h3>
                  {selectedFilters.length && (!desRecNavItemList || !desRecNavItemList.navItems.length) ? (
                    <Fragment>
                      <div className="lk-description lk-description--with-padding">
                        <FormattedMessage id="look.features.recommend.missingText"/>
                      </div>
                      <LookFiltersReset/>
                    </Fragment>
                  ) : null}
                  {desRecNavItemList ? (
                    <div className="lm-features lm-features--type-1">
                      {desRecNavItemList.navItems.map(navItem => {
                        return <LookListFeature lookFeature={navItem.part}
                                                key={navItem.part.dbFeature.id}
                                                navItems={desRecNavItemList.navItems}
                                                viewType="1"
                                                fromDesignRecommended={true}
                                                updateLookCartItem={updateLookCartItem}/>
                      })}
                    </div>
                  ) : null}
                </Fragment>
              ) : null}
              {regularNavItemList.navItems.length ? (
                <Fragment>
                  <h4 className="h3 lm-features__title2">
                    {regularNavItemList.navTranslate && notMatchingNavItemList.length ? <FormattedMessage id="look.features.other.view"/> : null}
                    {regularNavItemList.navTranslate && notMatchingNavItemList.length ? " " : null}
                    <FormattedMessage id={regularNavItemList.navTranslate && notMatchingNavItemList.length ? regularNavItemList.navTranslate : "look.features.other"}/>
                  </h4>
                  <div className={"lm-features lm-features--type-" + (lookViewTypeWasChanged ? lookViewType : "4")}>
                    {regularNavItemList.navItems.map(navItem => {
                      return <LookListFeature lookFeature={navItem.part}
                                              key={navItem.part.dbFeature.id}
                                              navItems={regularNavItemList.navItems}
                                              viewType={lookViewTypeWasChanged ? lookViewType : "4"}
                                              updateLookCartItem={updateLookCartItem}/>
                    })}
                  </div>
                </Fragment>
              ) : null}
              {notMatchingNavItemList.length ? notMatchingNavItemList.map((navItemList) => {
                return (
                  <Fragment key={navItemList.notMatchingMetaName}>
                    <h4 className="h3 lm-features__title2">
                      <FormattedMessage id={navItemList.navTranslate || "look.features.other"}/>
                    </h4>
                    <div className={"lm-features lm-features--type-" + (lookViewTypeWasChanged ? lookViewType : "4")}>
                      {navItemList.navItems.map(navItem => {
                        return <LookListFeature lookFeature={navItem.part}
                                                key={navItem.part.dbFeature.id}
                                                navItems={navItemList.navItems}
                                                viewType={lookViewTypeWasChanged ? lookViewType : "4"}
                                                updateLookCartItem={updateLookCartItem}/>
                      })}
                    </div>
                  </Fragment>
                )
              }) : null}
            </div>
            {navigationLoadingActive ? <NavigationLoader/> : null}
          </Fragment>
        )
      }}
    </WithUpdateLookCartItem>
  )
};

LookMainCategory.propTypes = {
  contentHeight: PropTypes.number
}

const mapStateToProps = (store) => {
  const {lookActiveFeature, lookViewType, lookActiveCategory, lookActiveFeaturePositionInList, lookViewTypeWasChanged,
    navigationCount, lookLockedTutorial, contextMenu, lookOverlayOpened} = store.lookState;
  const {visualizersLoaded, isMobile, allFeaturesWereLoaded} = store.serverState;
  const partId = lookActiveFeature ? lookActiveFeature.getParent().partId : "";
  const {selectedFilters, filterGroups} = store.filterState;
  const {groheFiltersSearchText, requiredButNotIncludedFeature} = store.groheState;
  const {wizardActiveItem} = store.wizardState;
  const {navigationLoadingActive} = store.navigationState;
  const {isPhoneNumberValidated} = store.userState;
  // const {activePreset} = store.bathroomVisualizerState;

  return {
    isMobile,
    lookActiveFeature,
    lookViewType,
    lookActiveCategory,
    lookViewTypeWasChanged,
    visualizersLoadedLength: visualizersLoaded.length,
    partId,
    fabricatorData: store.fabricatorState,
    filterGroups,
    groheFiltersSearchText,
    selectedFilters,
    requiredButNotIncludedFeature,
    lookActiveFeaturePositionInList,
    navigationCount,
    lookLockedTutorial,
    allFeaturesWereLoaded,
    contextMenu,
    wizardActiveItem,
    navigationLoadingActive,
    isPhoneNumberValidated,
    lookOverlayOpened,
  };
};

const mapDispatchToProps = {
  setGroheRequiredButNotIncludedFeature,
  setLookLockedTutorial,
  setNavigationLoading,
};

export default injectIntl (
  connect(mapStateToProps, mapDispatchToProps)(LookMainCategory)
);
